import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const NotificationFeed = () => {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([
  {
    id: 1,
    businessName: "Café Aroma Colombiano",
    businessLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1250e85be-1766879481924.png",
    businessLogoAlt: "Café Aroma Colombiano logo showing steaming coffee cup with Colombian flag colors in modern minimalist design",
    content: "¡Nueva promoción! Disfruta de nuestro café especial con 15% de descuento para miembros Elite. Válido todo diciembre.",
    media: "https://images.unsplash.com/photo-1595475038705-1af15f928681",
    mediaAlt: "Barista preparing specialty coffee with latte art in modern café setting with warm lighting and wooden counter",
    mediaType: "image",
    likes: 234,
    comments: 45,
    isLiked: false,
    postedAt: new Date(Date.now() - 7200000),
    discount: "15%",
    business: {
      id: 'biz_001',
      name: 'Café Aroma Colombiano',
      logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1250e85be-1766879481924.png",
      logoAlt: 'Café Aroma Colombiano logo showing steaming coffee cup with Colombian flag colors in modern minimalist design',
      category: 'Restaurantes y Cafeterías',
      discount: 15,
      rating: 4.8,
      address: 'Calle 18 #25-40, Centro, Pasto, Nariño',
      city: 'pasto',
      phone: '+57 312 456 7890',
      whatsapp: '573124567890',
      socialMedia: {
        facebook: 'https://facebook.com/aromacolombia',
        instagram: 'https://instagram.com/aromacolombia',
        twitter: ''
      }
    }
  },
  {
    id: 2,
    businessName: "Restaurante El Sabor Nariñense",
    businessLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_13c6b4c27-1766879481915.png",
    businessLogoAlt: "Restaurante El Sabor Nariñense logo featuring traditional Colombian food plate with colorful ingredients on rustic wooden background",
    content: "Descubre los auténticos sabores de Nariño. Platos típicos preparados con recetas tradicionales. ¡20% de descuento para todos los miembros!",
    media: "https://img.rocket.new/generatedImages/rocket_gen_img_19576deb2-1765291114255.png",
    mediaAlt: "Traditional Colombian dish with rice, beans, plantains and grilled meat served on ceramic plate with colorful presentation",
    mediaType: "image",
    likes: 567,
    comments: 89,
    isLiked: true,
    postedAt: new Date(Date.now() - 14400000),
    discount: "20%",
    business: {
      id: 'biz_002',
      name: 'Restaurante El Sabor Nariñense',
      logo: "https://img.rocket.new/generatedImages/rocket_gen_img_13c6b4c27-1766879481915.png",
      logoAlt: 'Restaurante El Sabor Nariñense logo featuring traditional Colombian food plate with colorful ingredients on rustic wooden background',
      category: 'Restaurantes',
      discount: 20,
      rating: 4.7,
      address: 'Carrera 25 #18-30, Pasto, Nariño',
      city: 'pasto',
      phone: '+57 318 765 4321',
      whatsapp: '573187654321',
      socialMedia: {
        facebook: 'https://facebook.com/sabornariñense',
        instagram: 'https://instagram.com/sabornariñense',
        twitter: ''
      }
    }
  },
  {
    id: 3,
    businessName: "Boutique Moda Elegante",
    businessLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1e85f4302-1766879480679.png",
    businessLogoAlt: "Boutique Moda Elegante logo displaying elegant fashion mannequin in designer clothing with modern retail store interior background",
    content: "Nueva colección de verano disponible. Encuentra las últimas tendencias en moda con 25% de descuento exclusivo para miembros Emprendedor y Elite.",
    media: "https://img.rocket.new/generatedImages/rocket_gen_img_1e85f4302-1766879480679.png",
    mediaAlt: "Fashion boutique interior with elegant clothing displays, modern lighting, and stylish summer collection on mannequins",
    mediaType: "image",
    likes: 892,
    comments: 156,
    isLiked: false,
    postedAt: new Date(Date.now() - 21600000),
    discount: "25%",
    business: {
      id: 'biz_003',
      name: 'Boutique Moda Elegante',
      logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1e85f4302-1766879480679.png",
      logoAlt: 'Boutique Moda Elegante logo displaying elegant fashion mannequin in designer clothing with modern retail store interior background',
      category: 'Moda y Accesorios',
      discount: 25,
      rating: 4.6,
      address: 'Carrera 27 #15-32, Pasto, Nariño',
      city: 'pasto',
      phone: '+57 320 456 7891',
      whatsapp: '573204567891',
      socialMedia: {
        facebook: 'https://facebook.com/modaelegante',
        instagram: 'https://instagram.com/modaelegante',
        twitter: 'https://twitter.com/modaelegante'
      }
    }
  },
  {
    id: 4,
    businessName: "Gimnasio FitLife Pasto",
    businessLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1a3c0391d-1766879481929.png",
    businessLogoAlt: "Gimnasio FitLife Pasto logo showing athletic person exercising with modern gym equipment in bright fitness center",
    content: "¡Transforma tu vida! Membresías mensuales con 30% de descuento. Incluye acceso a todas las clases grupales y asesoría personalizada.",
    media: "https://img.rocket.new/generatedImages/rocket_gen_img_12ad07008-1767915563369.png",
    mediaAlt: "Modern gym interior with rows of exercise equipment, bright lighting, and people working out in spacious fitness area",
    mediaType: "image",
    likes: 445,
    comments: 67,
    isLiked: true,
    postedAt: new Date(Date.now() - 28800000),
    discount: "30%",
    business: {
      id: 'biz_004',
      name: 'Gimnasio FitLife Pasto',
      logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1a3c0391d-1766879481929.png",
      logoAlt: 'Gimnasio FitLife Pasto logo showing athletic person exercising with modern gym equipment in bright fitness center',
      category: 'Deportes y Fitness',
      discount: 30,
      rating: 4.8,
      address: 'Avenida Libertador #30-45, Pasto, Nariño',
      city: 'pasto',
      phone: '+57 311 234 5679',
      whatsapp: '573112345679',
      socialMedia: {
        facebook: 'https://facebook.com/fitlifegym',
        instagram: 'https://instagram.com/fitlifegym',
        twitter: ''
      }
    }
  }]
  );

  const [showComments, setShowComments] = useState({});
  const [commentText, setCommentText] = useState({});
  const [showShareMenu, setShowShareMenu] = useState({});

  const handleBusinessClick = (business) => {
    navigate('/business-profile', { state: { business } });
  };

  const handleLike = (postId) => {
    setPosts(posts?.map((post) => {
      if (post?.id === postId) {
        return {
          ...post,
          isLiked: !post?.isLiked,
          likes: post?.isLiked ? post?.likes - 1 : post?.likes + 1
        };
      }
      return post;
    }));
  };

  const toggleComments = (postId) => {
    setShowComments((prev) => ({
      ...prev,
      [postId]: !prev?.[postId]
    }));
  };

  const handleCommentChange = (postId, value) => {
    setCommentText((prev) => ({
      ...prev,
      [postId]: value
    }));
  };

  const handleSendComment = (postId) => {
    const comment = commentText?.[postId]?.trim();
    if (comment) {
      setPosts(posts?.map((post) => {
        if (post?.id === postId) {
          return {
            ...post,
            comments: post?.comments + 1
          };
        }
        return post;
      }));
      setCommentText((prev) => ({
        ...prev,
        [postId]: ''
      }));
    }
  };

  const toggleShareMenu = (postId) => {
    setShowShareMenu((prev) => ({
      ...prev,
      [postId]: !prev?.[postId]
    }));
  };

  const handleShare = (postId, platform) => {
    const post = posts?.find((p) => p?.id === postId);
    const shareUrl = window.location?.href;
    const shareText = `${post?.businessName}: ${post?.content}`;

    switch (platform) {
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, '_blank');
        break;
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`, '_blank');
        break;
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`, '_blank');
        break;
      case 'copy':
        navigator.clipboard?.writeText(shareUrl);
        alert('Enlace copiado al portapapeles');
        break;
      default:
        break;
    }
    setShowShareMenu((prev) => ({
      ...prev,
      [postId]: false
    }));
  };

  const formatTimeAgo = (date) => {
    const seconds = Math.floor((new Date() - date) / 1000);
    if (seconds < 3600) return `Hace ${Math.floor(seconds / 60)} minutos`;
    if (seconds < 86400) return `Hace ${Math.floor(seconds / 3600)} horas`;
    return `Hace ${Math.floor(seconds / 86400)} días`;
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-card">
      <div className="p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-secondary/10">
            <Icon name="Bell" size={24} color="var(--color-secondary)" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">Notificaciones</h2>
            <p className="text-sm text-muted-foreground">Publicaciones de negocios</p>
          </div>
        </div>
      </div>
      <div className="divide-y divide-border max-h-[800px] overflow-y-auto">
        {posts?.map((post) =>
        <div key={post?.id} className="p-6">
            <div className="flex items-start gap-4 mb-4">
              <div
              className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-background cursor-pointer hover:opacity-80 transition-opacity"
              onClick={() => handleBusinessClick(post?.business)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e?.key === 'Enter' || e?.key === ' ') {
                  e?.preventDefault();
                  handleBusinessClick(post?.business);
                }
              }}>

                <img
                src={post?.businessLogo}
                alt={post?.businessLogoAlt}
                className="w-full h-full object-cover"
                onError={(e) => {e.target.src = '/assets/images/no_image.png';}} />

              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <p
                  className="text-sm font-semibold text-foreground cursor-pointer hover:text-primary transition-colors"
                  onClick={() => handleBusinessClick(post?.business)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e?.key === 'Enter' || e?.key === ' ') {
                      e?.preventDefault();
                      handleBusinessClick(post?.business);
                    }
                  }}>

                    {post?.businessName}
                  </p>
                  <div className="px-2 py-0.5 bg-success/10 rounded-full">
                    <span className="text-xs font-bold text-success">{post?.discount}</span>
                  </div>
                </div>
                <p className="text-xs text-muted-foreground">{formatTimeAgo(post?.postedAt)}</p>
              </div>
            </div>

            <p className="text-sm text-foreground mb-4 leading-relaxed">{post?.content}</p>

            {post?.media &&
          <div className="mb-4 rounded-lg overflow-hidden bg-muted" style={{ height: '400px' }}>
                <img
              src={post?.media}
              alt={post?.mediaAlt}
              className="w-full h-full object-cover"
              onError={(e) => {e.target.src = '/assets/images/no_image.png';}} />

              </div>
          }

            <div className="flex items-center gap-6 mb-4">
              <button
              onClick={() => handleLike(post?.id)}
              className="flex items-center gap-2 text-sm font-medium transition-colors hover:text-primary"
              style={{ color: post?.isLiked ? 'var(--color-primary)' : 'var(--color-muted-foreground)' }}>

                <Icon name={post?.isLiked ? "Heart" : "Heart"} size={20} fill={post?.isLiked ? "currentColor" : "none"} />
                <span>{post?.likes}</span>
              </button>
              <button
              onClick={() => toggleComments(post?.id)}
              className="flex items-center gap-2 text-sm font-medium text-muted-foreground transition-colors hover:text-primary">

                <Icon name="MessageCircle" size={20} />
                <span>{post?.comments}</span>
              </button>
              <div className="relative">
                <button
                onClick={() => toggleShareMenu(post?.id)}
                className="flex items-center gap-2 text-sm font-medium text-muted-foreground transition-colors hover:text-primary">
                  <Icon name="Share2" size={20} />
                  <span>Compartir</span>
                </button>
                {showShareMenu?.[post?.id] &&
              <div className="absolute bottom-full mb-2 right-0 bg-card border border-border rounded-lg shadow-lg p-2 min-w-[180px] z-10">
                    <button
                  onClick={() => handleShare(post?.id, 'facebook')}
                  className="w-full flex items-center gap-3 px-3 py-2 text-sm text-foreground hover:bg-muted rounded-md transition-colors">

                      <Icon name="Facebook" size={18} />
                      <span>Facebook</span>
                    </button>
                    <button
                  onClick={() => handleShare(post?.id, 'twitter')}
                  className="w-full flex items-center gap-3 px-3 py-2 text-sm text-foreground hover:bg-muted rounded-md transition-colors">

                      <Icon name="Twitter" size={18} />
                      <span>Twitter</span>
                    </button>
                    <button
                  onClick={() => handleShare(post?.id, 'whatsapp')}
                  className="w-full flex items-center gap-3 px-3 py-2 text-sm text-foreground hover:bg-muted rounded-md transition-colors">

                      <Icon name="MessageCircle" size={18} />
                      <span>WhatsApp</span>
                    </button>
                    <button
                  onClick={() => handleShare(post?.id, 'copy')}
                  className="w-full flex items-center gap-3 px-3 py-2 text-sm text-foreground hover:bg-muted rounded-md transition-colors">

                      <Icon name="Copy" size={18} />
                      <span>Copiar enlace</span>
                    </button>
                  </div>
              }
              </div>
            </div>

            {showComments?.[post?.id] &&
          <div className="pt-4 border-t border-border">
                <div className="flex gap-3">
                  <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name="User" size={16} color="var(--color-primary)" />
                  </div>
                  <div className="flex-1 flex gap-2">
                    <input
                  type="text"
                  placeholder="Escribe un comentario..."
                  value={commentText?.[post?.id] || ''}
                  onChange={(e) => handleCommentChange(post?.id, e?.target?.value)}
                  onKeyPress={(e) => {
                    if (e?.key === 'Enter') {
                      handleSendComment(post?.id);
                    }
                  }}
                  className="flex-1 px-4 py-2 bg-muted rounded-lg text-sm text-foreground placeholder:text-muted-foreground border border-border focus:outline-none focus:ring-2 focus:ring-primary" />
                    <button
                  onClick={() => handleSendComment(post?.id)}
                  disabled={!commentText?.[post?.id]?.trim()}
                  className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">

                      <Icon name="Send" size={16} />
                      <span>Enviar</span>
                    </button>
                  </div>
                </div>
              </div>
          }
          </div>
        )}
      </div>
    </div>);



};

export default NotificationFeed;